export const environment = {
  production: true,
  apiBaseUrl: 'https://api.segrega.es',
  // apiBaseUrl: 'https://node2-mbp.local.arsa.dev',
  apiKeyAdmin: '',
};
